<div class="checkbox-input" [ngClass]="{ active: active }" (click)="toggle()">
  <svg
    viewBox="0 0 21.02 14.02"
    [style.background-color]="active ? color : null"
    [style.fill-opacity]="active ? 1 : 0"
    [style.top]="top"
    [style.border-color]="color"
  >
    <path
      fill-rule="evenodd"
      d="M21.498,2.349 L8.886,14.965 L0.479,6.555 L1.880,5.153 L8.886,12.161 L20.096,0.948 L21.498,2.349 Z"
    />
  </svg>
</div>
